import jQuery from "jquery";

/**
 * Visual spinner that can be attached to a document.
 * Visibility is controlled by "push" and "pop", which keep track of depth (ie two pushes require two pops to undo)
 */
export class Spinner {

    private elt : JQuery<HTMLElement>;
    private depth = 0;

    constructor() {
        const html = `
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
`;
        this.elt = jQuery(html);
    }

    attach(document: Document) {
        const body = jQuery(document).find("body");
        body.append(this.elt);
        this.elt.data("spinner", this);
        this.config();
    }

    private push() {
        this.depth ++;
        this.config();
    }

    private pop() {
        this.depth --;
        this.config();
    }

    private config() {
        if (this.depth > 0) {
            this.elt.show();
        } else {
            this.elt.hide();
        }
    }

    private static find() : Spinner {
        return jQuery(document).find(".lds-ring").data("spinner");
    }

    static pushSpinner() : () => void {
        const s = Spinner.find();
        s && s.push();
        return () => {
            s && s.pop();
        };
    }
}

